<template>
    <v-container fluid px-3 pt-3>
        <v-row row wrap>
            <v-col cols="12">
                <h3>Request Details</h3>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row row wrap v-if="!!searchDto">
            <v-col cols="4">
                <b>Verification Request ID:</b> {{ searchDto.verificationRequestId }}
            </v-col>
            <v-col cols="4">
                <b>Request Date:</b> {{ searchDto.requestDate }}
            </v-col>
            <v-col cols="4">
                <b>State File Number:</b> {{ responseDto.stateFileNumber }}
            </v-col>
        </v-row>
        <v-row v-if="responseDto.modType == 10 || responseDto.modType == 40">
            <v-col cols="6">
                <b>Birth Name:</b> {{ responseDto.firstName }} {{ responseDto.middleName }} {{ responseDto.lastName }}
            </v-col>
            <v-col cols="6">
                <b>Birth Date:</b> {{ responseDto.dateOfBirth }}
            </v-col>
        </v-row>
        <v-row v-else-if="responseDto.modType == 20 || responseDto.modType == 30">
            <v-col cols="4">
                <b>Spouse 1 Name:</b> {{ responseDto.firstName }} {{ responseDto.middleName }} {{ responseDto.lastName }}
            </v-col>
            <v-col cols="4">
                <b>Spouse 2 Name:</b> {{ responseDto.firstName2 }} {{ responseDto.middleName2 }} {{ responseDto.lastName2 }}
            </v-col>
            <v-col cols="4">
                <b>Record Year:</b> {{ responseDto.recordYear }}
            </v-col>
        </v-row>
        <v-row v-if="responseDto.modType == 10">
            <v-col cols="6" v-if="!!responseDto.parent1FirstName">
                <b>Parent 1 Name:</b> {{ responseDto.parent1FistName }} {{ responseDto.parent1MiddleName }} {{ responseDto.parent1LastName }}
            </v-col>
            <v-col cols="6" v-if="!!responseDto.parent2FirstName">
                <b>Parent 2 Name:</b> {{ responseDto.parent2FistName }} {{ responseDto.parent2MiddleName }} {{ responseDto.parent2LastName }}
            </v-col>
        </v-row>
        <v-row v-if="!!searchDto">
            <v-col cols="12">
                <h3>Verification Search Details</h3>
                <v-divider></v-divider>
            </v-col>
            <v-col cols="4">
                <b>Name 1:</b> {{ searchDto.firstName }} {{ searchDto.middleName }} {{ searchDto.lastName }}
            </v-col>
            <v-col cols="4" >
                <b>Birth Date 1:</b> {{ searchDto.dateOfBirth }}
            </v-col>
            <v-col cols="4" v-if="!!searchDto.firstName2">
                <b>Name 2:</b> {{ searchDto.firstName2 }} {{ searchDto.middleName2 }} {{ searchDto.lastName2 }}
            </v-col>
            <v-col cols="4" v-if="!!searchDto.dateOfBirth2">
                <b>Birth Date 2:</b> {{ searchDto.dateOfBirth2 }}
            </v-col>
            <v-col cols="4" v-if="!!searchDto.parent1FirstName">
                <b>Parent 1 Name:</b> {{ searchDto.parent1FistName }} {{ searchDto.parent1MiddleName }} {{ searchDto.parent1LastName }}
            </v-col>
            <v-col cols="4" v-if="!!searchDto.parent2FirstName">
                <b>Parent 2 Name:</b> {{ searchDto.parent2FistName }} {{ searchDto.parent2MiddleName }} {{ searchDto.parent2LastName }}
            </v-col>
            <v-col cols="4" v-if="!!searchDto.recordYear">
                <b>Record Year:</b> {{ searchDto.recordYear }}
            </v-col>
        </v-row>
        <v-row v-if="!!previousMessages">
            <v-col cols="12">
                <h3>Messages</h3>
                <v-divider></v-divider>
            </v-col>
            <v-col cols="12" v-for="message in previousMessages" :key="message.portalInboxMailId">
                <b>From:</b> {{ message.fromUsername }}
                <br>
                <b>Date:</b> {{ message.sentDate }}
                <br>
                <b>Message:</b>
                <div style="white-space: pre-line">{{ message.message }}</div>
                <br>
            </v-col>
        </v-row>
        <v-btn v-if="canPrint" @click="print()" color="secondary" :disabled="isLoading">Print File</v-btn>
        <v-btn @click="acknowledge()" color="secondary" :disabled="isLoading">Acknowledge</v-btn>
    </v-container>
</template>

<script>
import mailService from '@/services/mailService'
import mediaService from '@/services/mediaService'
export default {
    data: () => {
        return {
            messageType: '',
            isLoading: false,
            responseDto: {
                verificationRequestId: '',
                modType: '',
                requestDate: '',
                requestName: '',
                firstName: '',
                middleName: '',
                lastName: '',
                dateOfBirth: '',
                firstName2: '',
                middleName2: '',
                lastName2: '',
                dateOfBirth2: '',
                parent1FirstName: '',
                parent1MiddleName: '',
                parent1LastName: '',
                parent2FirstName: '',
                parent2MiddleName: '',
                parent2LastName: '',
                recordYear: '',
                recordId: '',
                stateFileNumber: '',
                verificationReason: ''
            },
            searchDto: {
                verificationRequestId: '',
                requestDate: ''
            },
            previousMessages: []
        }
    },
    computed: {
        canPrint () {
            if (this.previousMessages.length == 0) {
                return false
            }
            var retDate = new Date(this.previousMessages[0].sentDate)
            retDate.setDate(retDate.getDate() + 14)
            return (this.messageType == 1 || this.messageType == 8) && new Date() <= retDate
        }
    },
    mounted: function () {
        mailService.mailDetails(this.$http, this.$route.params.id).then(response => {
            if (response.data.matchedRecord) { this.responseDto = response.data.matchedRecord }
            this.searchDto = response.data.searchDto
            this.previousMessages = response.data.previousMessages
            this.messageType = this.$route.params.type
        })
    },
    methods: {
        print () {
            if (this.messageType == 1) {
                this.printAbstract()
            } else if (this.messageType == 8) {
                this.printAffidavit()
            }
        },
        printAbstract () {
            this.isLoading = true
            mailService.printAbstract(this.$http, this.searchDto.verificationRequestId).then(response => {
                mediaService.fileToDownload(response, 'abstract_request' + this.searchDto.verificationRequestId + '.pdf')
                this.isLoading = false
            })
        },
        printAffidavit () {
            this.isLoading = true
            mailService.printAffidavit(this.$http, this.searchDto.verificationRequestId).then(response => {
                mediaService.fileToDownload(response, 'paternity_affidavit_request' + this.searchDto.verificationRequestId + '.pdf')
                this.isLoading = false
            })
        },
        acknowledge () {
            this.isLoading = true
            mailService.acknowledgeMail(this.$http, this.$route.params.id).then(response => {
                this.isLoading = false
                this.$router.push('/inbox')
            })
        }
    }
}
</script>
